import popupController from './popup-controller';

import {createComponents, destroyComponents} from '../../base/component-loader';

class Popup {
    options = {
        contentElementSelector: '[data-popup-content]',
        closeButtonAttribute: 'data-popup-close',
        defaultErrorMessageAttribute: 'data-default',
        activeClassName: '-visible',
        hasContentClassName: '-has-content',
    };

    /**
     * @type {HTMLElement}
     */
    element;

    /**
     * @type {HTMLElement}
     */
    contentElement;

    /**
     * @type {Function}
     */
    onKeyDownBound;

    /**
     * @type {Function}
     */
    onClickInPopupBound;

    constructor(el) {
        this.element = el;
    }

    init() {
        this.onKeyDownBound = this.onKeyDown.bind(this);
        this.onClickInPopupBound = this.onClickInPopup.bind(this);

        this.setup();
        this.attachEventListeners();
    }

    destroy() {
        this.detachEventListeners();
        this.detachEventListeners();
    }

    setup() {
        this.contentElement = this.element.querySelector(this.options.contentElementSelector);
    }

    attachEventListeners() {
        this.element.addEventListener('click', this.onClickInPopupBound);
    }

    detachEventListeners() {
        this.element.removeEventListener('click', this.onClickInPopupBound);
        document.removeEventListener('keydown', this.onKeyDownBound);
    }

    onClickInPopup(e) {
        let current = e.target;
        while (current !== this.element && current !== null) {
            if (current.hasAttribute(this.options.closeButtonAttribute)) {
                this.close();
                return;
            }
            current = current.parentElement;
        }
    }

    onKeyDown(e) {
        if (e.keyCode === 27) {
            this.close();
        }
    }

    /**
     * @return {HTMLElement}
     */
    getContentElement() {
        return this.contentElement;
    }

    /**
     * @return {HTMLElement}
     */
    getElement() {
        return this.element;
    }

    /**
     * @param {String|null} content
     */
    setContent(content) {
        destroyComponents(this.contentElement);

        this.contentElement.innerHTML = content || '';
        if (content === null) {
            this.element.classList.remove(this.options.hasContentClassName);
        } else {
            this.element.classList.add(this.options.hasContentClassName);
        }

       createComponents(this.contentElement);
    }

    /**
     * @param {String|null} message
     */
    setError(message) {
        const errorHtml = this.element.getAttribute(this.options.errorDataAttribute);
        this.setContent(errorHtml);

        const errorMessageElement = this.contentElement.querySelector(this.options.errorMessageElementSelector);
        let errorMessage = message;
        if (errorMessage === null) {
            errorMessage = errorMessageElement.getAttribute(this.options.defaultErrorMessageAttribute);
        }

        errorMessageElement.innerHTML = errorMessage;
    }

    isOpen() {
        return this.element.classList.contains(this.options.activeClassName);
    }

    open() {
        document.querySelector('body').classList.add('-no-overflow');
        this.element.classList.add(this.options.activeClassName);
        document.addEventListener('keydown', this.onKeyDownBound);
    }

    close() {
        document.querySelector('body').classList.remove('-no-overflow');
        this.element.classList.remove(this.options.activeClassName);
        document.removeEventListener('keydown', this.onKeyDownBound);

        this.element.dispatchEvent(new CustomEvent('close'));
    }
}

export default (element) => {
    const popup = new Popup(element);
    popup.init();
    popupController.setPopup(popup);
};
